function getSwatchCSSVariables() {
  var bodyStyles = window.getComputedStyle(document.body);
  var swatchCSSVariables = {
    itemWidth: parseInt(bodyStyles.getPropertyValue('--swatch_width')),
    itemMargin: parseInt(bodyStyles.getPropertyValue('--swatch_margin')),
    itemsToShow: parseInt(bodyStyles.getPropertyValue('--swatches_to_show'))
  };
  return swatchCSSVariables;
}
var transitionDuration = '50';
$(document).ready(function() {
  $(document).on('click', '.swatchCarousel i', function() {
    var chevron = $(this);
    var associatedChevron = $(this).siblings("i");
    if (!chevron.hasClass("disabled")) {
      var itemsToShow = getSwatchCSSVariables().itemsToShow;
      var itemWidth = getSwatchCSSVariables().itemWidth;
      var itemMargin = getSwatchCSSVariables().itemMargin;
      var swatchContainer = $(this).siblings(".swatchWrapper").find(".coloursAvailableSwatches"), associatedChevron = $(this).siblings("i");
      var itemCount = parseInt(swatchContainer.attr('data-item-count')), currentIndex = parseInt(swatchContainer.attr('data-offset'));

      if (swatchContainer.parents('.reusableCarouselItems').length) {
        itemMargin -= 2;
      }
      
      if (chevron.hasClass("fa-chevron-right")) {
        var remainingItems = itemCount - (itemsToShow + currentIndex);
        itemsToShow > remainingItems ? currentIndex += remainingItems : currentIndex += itemsToShow;
        currentIndex < itemCount - itemsToShow ? $(this).removeClass('disabled') : $(this).addClass('disabled');
        currentIndex > 0 ? associatedChevron.removeClass('disabled') : associatedChevron.addClass('disabled');
      }
      else {
        itemsToShow > currentIndex ? currentIndex = 0 : currentIndex -= itemsToShow;
        currentIndex > 0 ? $(this).removeClass('disabled') : $(this).addClass('disabled');
        currentIndex < itemCount - itemsToShow ? associatedChevron.removeClass('disabled') : associatedChevron.addClass('disabled');
      }
      swatchContainer.attr('data-offset', currentIndex);
      offset = (itemWidth + itemMargin) * currentIndex * -1;
      console.log("itemMargin", itemMargin);
      console.log("itemWidth", itemWidth);
      console.log("offset", offset);
      console.log(getSwatchCSSVariables());
      swatchContainer.css({"transform": `translate3d(${offset}px, 0px, 0px)`, 'transition-duration': `${transitionDuration * itemsToShow}ms`});
      swatchContainer.attr("data-offset", currentIndex);
    }
  });
  $(document).on('click', '.swatchPreview', function() {
    var currentSwatch = $(this);
    var currentItem = $(this).parents(".item");
    var variantPrice = currentSwatch.attr("data-variant-price"), variantTitle = currentSwatch.attr("data-variant-title"), variantColour = currentSwatch.attr("data-variant-colour"),
        variantRRP = currentSwatch.attr("data-variant-rrp"), variantID = currentSwatch.attr("data-variant-id"), swatchPreviewURL = currentSwatch.attr("data-variant-preview-src"), swatchURL = currentSwatch.attr("data-variant-src");
    var parentItem = currentSwatch.parents(".item"), productImage = parentItem.find(".product-image"), variantTitleElement = parentItem.find(".variantTitle");
    var nowPrice = parentItem.find(".nowPrice"), savePrice = parentItem.find(".savePrice"), financePrice = parentItem.find(".financePriceContainer strong"), creditPrice = parentItem.find(".creditPrice strong"),
        financeDetails = parentItem.find(".financePriceContainer .termDetails"), creditDetails = parentItem.find(".creditPrice .termDetails");
    nowPrice.text(`£${variantPrice}`);
    savePrice.text(`£${variantRRP - variantPrice}`);
  
    var yearAmount = 5;
    if (variantPrice >= 2000) {
      variantPrice = (variantPrice / 100) * 75;
      yearAmount = 5;
      creditDetails.text("a month for 5 years, 25% deposit");
      financeDetails.text("5 years | 25% deposit");
    }
    else if (variantPrice >= 300 && variantPrice < 2000) {
      yearAmount = 3;
      creditDetails.text("a month for 3 years, no deposit");
      financeDetails.text("3 years | no deposit");
    }
    
    var monthAmount = yearAmount * 12;
    var financeAmount = (variantPrice/monthAmount);
    financeAmount = Math.floor(financeAmount * 100) / 100;
    financeAmount = financeAmount.toString();
    if (financeAmount.split(".")[1].length == 1) {
      financeAmount = `${financeAmount}0`;
    }
    financePrice.text(`£${financeAmount}`);
    creditPrice.text(`£${financeAmount}`);
    
    var shopNowLink = parentItem.data("link").split("?")[0], shopNowButton = parentItem.find(".shop-now"), imageLink = parentItem.find(".product-image-wrap .image");
    var variantURL = `${shopNowLink}?variant=${variantID}`
  
    $(this).addClass("activeSwatch");
    $(this).siblings().removeClass("activeSwatch");
  
    imageLink.attr("href", variantURL);
    shopNowButton.attr("href", variantURL);
    currentItem.addClass("preview");
    productImage.attr("src", swatchPreviewURL);
    productImage.attr("src", swatchURL).load(function() {
      if (currentItem.hasClass("preview")) {
        productImage.attr("src", swatchURL);
      }
    });
      currentItem.removeClass("preview");
    variantTitleElement.text(variantColour);
  });
});